import { C, STROKE, Figure, Label, Leader, ThermostatValve, arrow } from './figureStyle';

const ID = 'fig-tre-tjek';

const highlight = { fill: 'none', stroke: C.rust, strokeWidth: STROKE.secondary, strokeDasharray: '3 4' };

export default function TreTjekFigure() {
  return (
    <Figure
      id={ID}
      height={250}
      title="Skitse af varmeanlæg og radiator, hvor tre steder er markeret: manometeret på varmeanlægget, fremløbsrøret frem til radiatoren og ventilstiften bag termostathovedet."
      caption="De tre ting at tjekke efter udluftning: ventilstiften bag termostathovedet, anlæggets manometer og fremløbsrøret frem til radiatoren."
    >
      {/* Varmeanlæg med manometer */}
      <rect x="14" y="56" width="86" height="164" rx="6" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <circle cx="57" cy="100" r="16" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />
      <line x1="57" y1="100" x2="66" y2="90" stroke={C.dark} strokeWidth={STROKE.secondary} />
      <circle cx="57" cy="100" r="2" fill={C.dark} />

      {/* Fremløb til termostatventilen */}
      <path d="M100,80 H160 V126 H180" fill="none" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />
      <line x1="210" y1="126" x2="222" y2="126" stroke={C.rust} strokeWidth={STROKE.outline} />
      <ThermostatValve cx={197} pipeY={126} />

      {/* Radiator */}
      <rect x="222" y="110" width="124" height="110" rx="6" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Retur */}
      <line x1="222" y1="204" x2="104" y2="204" stroke={C.grey} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'cold')} />

      {/* De tre steder at tjekke */}
      <circle cx="57" cy="100" r="24" {...highlight} />
      <ellipse cx="130" cy="80" rx="22" ry="12" {...highlight} />
      <rect x="178" y="74" width="38" height="66" rx="10" {...highlight} />

      {/* Labels */}
      <Label x={57} y={138} anchor="middle" lines={['Manometer']} />
      <Label x={57} y={180} anchor="middle" lines={['Varmeanlæg']} />
      <Label x={130} y={44} anchor="middle" lines={['Fremløbsrør']} />
      <Leader points="130,50 130,66" />
      <Label x={356} y={40} anchor="end" lines={['Ventilstift']} />
      <Label x={356} y={56} anchor="end" kind="note" lines={['bag termostathovedet']} />
      <Leader points="232,62 214,78" />
      <Label x={284} y={170} anchor="middle" lines={['Radiator']} />
    </Figure>
  );
}
